import { isAfter } from 'date-fns';
import { useContext } from 'react';

import { UserContext } from 'context/UserContext';

import { getUserAnonToken } from 'services/User';

import { getAnonAuth, setAnonAuthToStorage } from 'utils/storageUtils';

export const useAnonAuth = () => {
  const { user } = useContext(UserContext);

  const waitForAnonAuth = (maxRetries = 10, delay = 100): Promise<any> => new Promise((resolve, reject) => {
    let attempts = 0;

    const check = async () => {
      const storageAnonAuth = getAnonAuth();

      if (storageAnonAuth?.token) {
        const isValid = isAfter(storageAnonAuth?.expiresAt, new Date().getTime());

        if (isValid) {
          resolve(storageAnonAuth);
        } else {
          const responseAnonToken = await getUserAnonToken(user?.uid);
          setAnonAuthToStorage(responseAnonToken?.data);
          resolve(responseAnonToken?.data);
        }
      } else if (attempts >= maxRetries) {
        reject(new Error('Anon auth not available'));
      } else {
        attempts += 1;
        setTimeout(check, delay);
      }
    };

    check();
  });

  return { waitForAnonAuth };
};
